import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// REACT-SELECT COMPONENTS
import { components } from 'react-select';

// STYLES
import styles from '../select.module.scss';

// MAIN COMPONENT
const Menu = ({ className, innerProps, ...props }) => (
  <components.Menu
    className={clsx(
      'select-menu',
      styles.menu,
      className
    )}
    innerProps={Object.assign({}, innerProps, {
      'data-placement': props.placement
    })}
    {...props}
  />
)

// EXPORT
export default Menu